import { a146, a163, a734, rg001 } from "Components/Api/RootApiPath";

export const fetchAllSku = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a163, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch invoice list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchAllStones = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a734, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch invoice list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};